import React, { useState } from "react"
import { scroller } from "react-scroll"
import { Navbar, Nav } from "react-bootstrap"

const headerOffset = -65

const NavBar = () => {
  const [expanded, setExpanded] = useState(false)
  const [pendingTarget, setPendingTarget] = useState(null)

  const scrollToSection = target => {
    scroller.scrollTo(target, {
      smooth: true,
      duration: 500,
      offset: headerOffset,
    })
  }

  const handleNavClick = target => {
    if (expanded) {
      setPendingTarget(target)
      setExpanded(false)
      return
    }

    scrollToSection(target)
  }

  const handleCollapseExited = () => {
    if (!pendingTarget) {
      return
    }

    scrollToSection(pendingTarget)
    setPendingTarget(null)
  }

  return (
    <Navbar
      bg="#ac9393ff"
      expand="md"
      expanded={expanded}
      onToggle={nextExpanded => setExpanded(Boolean(nextExpanded))}
      sticky="top"
      style={{
        background: "#263f35ff",
        padding: "5px 5px 5px 5px",
      }}
    >
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse
        id="basic-navbar-nav"
        className="justify-content-end"
        onExited={handleCollapseExited}
      >
        <Nav.Item>
          <Nav.Link
            className="nav-link"
            onClick={() => handleNavClick("reservation")}
            style={{
              padding: "20px 28px",
              cursor: "pointer",
            }}
          >
            Ajanvaraus
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            className="nav-link"
            onClick={() => handleNavClick("pricelist")}
            style={{
              padding: "20px 29px",
              cursor: "pointer",
            }}
          >
            Hinnasto
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            className="nav-link"
            onClick={() => handleNavClick("gallery")}
            style={{
              padding: "20px 28px",
              cursor: "pointer",
            }}
          >
            Galleria
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            className="nav-link"
            onClick={() => handleNavClick("contact")}
            style={{
              padding: "20px 28px",
              cursor: "pointer",
            }}
          >
            Yhteystiedot
          </Nav.Link>
        </Nav.Item>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavBar
